<template>
  <div>
    <van-nav-bar
      title="审批管理"
      :left-text="'您好，' + userInfo.emp_name"
    />
    <van-row>
      <van-col :span="18">
        <base-input v-model="queryCondition.code" label="单号" />
      </van-col>
      <van-col :span="6" style="text-align: right; padding-right: 10px;">
        <base-button @click="query">查询</base-button>
      </van-col>
    </van-row>
    <van-col :span="24">
      <van-pull-refresh v-model="refreshing" @refresh="query">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="query"
        >
          <van-cell v-for="row in data" :key="row.id">
            <van-panel :title="row.code" :desc="'申请时间：' + row.create_time"
                       :status="CONST.APPROVE_STATUS.find(status => status.id === row.approve_status).name">
              <div>
                <van-row>
                  <van-col :span="20">
                    审批事项：{{ row.approve_item_name }}
                  </van-col>
                  <van-col :span="4" style="text-align: right;">
                    <span class="tip-msg">{{ row.op_flow | fmConst('APPROVE_OP_FLOW') }}</span>
                  </van-col>
                </van-row>
              </div>
              <div slot="footer">
                <van-row>
                  <van-col :span="12">
                    <span style="font-weight: bold;">￥{{ row.approve_amount | toThousandFilter }}</span>
                  </van-col>
                  <van-col :span="12" style="text-align: right;">
                    <base-button type="warning" @click="handleModify(row)">修改</base-button>
                    <base-button type="danger" @click="handleDelete(row)">删除</base-button>
                  </van-col>
                </van-row>
              </div>
            </van-panel>
          </van-cell>
        </van-list>
      </van-pull-refresh>
    </van-col>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getApproveInfoList, deleteApproveInfo } from '@/api/settings/approve-info'
export default {
  name: 'ApproveInfoManage',
  data() {
    return {
      data: [],
      loading: false,
      finished: false,
      refreshing: false,

      queryCondition: {
        total: this.CONST.PAGINATION.TOTAL,
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.MAX_ROWS,
        sort: 'id',
        order: 'desc',
        code: ''
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted() {
    this.query()
  },
  methods: {
    query() {
      this.data = []
      this.loading = true
      this.finished = false
      this.refreshing = false
      getApproveInfoList(this.queryCondition).then(resp => {
        this.data = resp.rows || []
        this.queryCondition.total = resp.total.count
        this.loading = false
        this.finished = true
      }).catch(() => {
        this.loading = false
        this.finished = true
      })
    },
    handleModify(row) {
      localStorage.setItem('approveInfoModel', JSON.stringify(row))
      this.$router.push('/approve-info/apply')
    },
    handleDelete(row) {
      this.confirm('确定删除审批吗？').then(() => {
        deleteApproveInfo({
          id: row.id
        }).then(resp => {
          this.success(resp.msg)
          this.query()
        })
      }).catch(_ => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/approve-info/manage.vue